import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';

export const Root = styled.div`
  font-family: 'Roboto', sans-serif;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const MainBody = styled.div`
  flex: 1;
`;

export const Section = styled.div`
  padding: 32px;
`;

export const MacroHeading = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 18px;
  font-weight: 500;
`;

export const MacroAvatar = styled.div`
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: ${colors.purple10};

  & svg {
    color: ${colors.white};
    --accent-color: ${colors.purple10};
  }
`;

export const MacroText = styled.div`
  padding: 8px 12px 32px;
  border: 1px solid ${colors.lightGray21};
  border-radius: 3px;
  font-size: 11px;
  line-height: 16px;
  font-weight: 400;
  color: ${colors.black4};
  margin: 0 0 26px;
  white-space: break-spaces;
`;

export const MacroActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

export const MacroActionsButtonsGroup = styled.div`
  display: flex;
  gap: 8px;
`;

export const MacroActionsCopiedText = styled.p`
  margin: 0;
  font-size: 11px;
  line-height: 16px;
  font-weight: 400;
  color: ${colors.darkGray1};
  opacity: 0;
  transform: translate(0, 8px);
  transition-property: transform, opacity;
  transition-duration: 400ms, 400ms;
  transition-timing-function: ease, linear;

  &.enter-active,
  &.enter-done {
    opacity: 1;
    transform: translate(0, 0);
  }
`;
